// @flow

import _ from "lodash"

// TODO: Not like it
// eslint-disable-next-line flowtype/no-weak-types
export const convertToBool = (bool: any): boolean => {
  if (_.isBoolean(bool)) return bool
  return bool !== "" && (bool === "true" || bool === "True")
}

export default convertToBool
